/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function ($, SCS) {
	"use strict";
	/*globals Tc */
	/*jshint smarttabs:true */

	/**
	 * PexArticleList module implementation.
	 *
	 * @author Dave Talamona
	 * @namespace Tc.Module
	 * @class PexArticleList
	 * @extends Tc.Module
	 */
	Tc.Module.PexArticleList = Tc.Module.extend({

		/**
		 * Hook function to do all of your module stuff.
		 *
		 * @method on
		 * @param {Function} callback function
		 * @return void
		 */
		on: function(callback) {
			var mod = this,
				$ctx = mod.$ctx, 
				$articleList = $ctx.find("ul.article-list");

			// Check for mobile news list
			if (SCS.utils.isMobilePage() && 
				!$articleList.hasClass("isPromotions") && 
				!$articleList.hasClass('article-list-new-business')) {
					mod.setMobileNewsList($articleList);
			}
			
			// Load more atricles
			mod.numOfVisibleArticles = $articleList.find('.article-list-item:not(.hidden)').length;
			$ctx.find('.loadMore').on('click', function () {
				$articleList.find('.article-list-item.hidden').filter(':lt(' + mod.numOfVisibleArticles + ')').removeClass('hidden');
				mod.checkLoadMore();
			});
			
			mod.checkLoadMore();

			callback();
		},

		checkLoadMore: function () {
			var mod = this,
				$ctx = mod.$ctx;

			if (!$ctx.find('.article-list-item.hidden').length) {
				$ctx.find('.loadMore').hide();
			}
		},
		
		
		/**
		 * Set mobile view for news list
		 * 
		 * @param $articleList {Object} List element 
		 */
		setMobileNewsList: function($articleList) {
			var mod = this,
				$element,
				$link;
			
			$articleList.find('> li').each(function(){
				$element = $(this);
				$link = $element.find('.link');
				
				$link.css('display','none');
				$element.append("<div class='chevron'></div>");
				$element.wrapInner('<a href="' + $link.attr('href') + '" style="navigation-simple scs-linklist-simple ui-link"></a>');
			});
		}
	});
}(Tc.$, window.SCS));
}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.PexArticleList.js
// module id = 159
// module chunks = 0